const foreignWorkerGroupQuery = (id) => {
  return `
  query {
    deleteForeignWorkerGroup(id: "${id}")
  }
  `;
};

export default foreignWorkerGroupQuery;
